<template>
  <q-btn
    v-if="isFullyLoaded"
    :data-test="CypressTarget('Buy')"
    :label="labelText"
    v-bind="quasarButtonProps"
    size="17px"
    rounded
    class="q-pl-lg q-pr-lg q-mr-lg"
    @click="$emit('addToCart')"
  >
    <slot />
  </q-btn>
</template>
<script>
  import QuasarButtonProps from 'mixins/components/button/common/quasarButtonProps';
  import FullyLoaded from '../../../mixins/event/FullyLoaded';

  export default {
    name: 'BuyButton',
    mixins: [QuasarButtonProps, FullyLoaded],
    props: {
      freeSale: {
        type: Boolean,
        required: false,
        default: false,
      },
      flat: {
        type: Boolean,
        required: false,
        default: true,
      },
      sparse: {
        type: Boolean,
        required: false,
        default: true,
      },
      label: {
        type: String,
        required: false,
        default: '',
      },
    },
    computed: {
      labelText() {
        const defaultLabel = this.freeSale ? this.$t('button.buy') : this.$t('button.finish');
        return this.label ? this.label : defaultLabel;
      },
    },
  };
</script>
